import { useState } from 'react';
import { useSelector } from 'react-redux';

import { Box, Divider, Stack, Typography } from '@mui/material';
import ImageListItem from '@mui/material/ImageListItem';

import BackgroundImage from '../../shared/image/placeholder.jpg';

import './index.scss';
import Wysiwyg from '../shared/Wysiwyg';
import { Link } from 'react-router-dom';
import useSWR from 'swr';

function HorizontalCard({ item = {}, url, topHeading = null, footerAction = null, handleClick = () => {}, selected = false, detailsUrl, detailsPayload, detailsResponseHandler }) {
  const retailer = useSelector(state => state.retailer);
  
  const placeholderImage = retailer.placeholder_image ?
  `${process.env.REACT_APP_API_URL}/assets/${retailer.placeholder_image}`
  : BackgroundImage;
  
  const imageTransformationKey = item?.url?.includes('key') ? '' : '?key=brand-portal-image-card-square';

  const [imageSource, setImageSource] = useState(`${item.url || placeholderImage}${imageTransformationKey}`);

    const { data: barcodeResponse } = useSWR((!detailsUrl || !detailsPayload) ? null : {
      url: detailsUrl,
      fields: '*',
      ...detailsPayload,
    });

    let processedData;

    if (barcodeResponse) {
      processedData = detailsResponseHandler(barcodeResponse);
    }

  const CardContainer = ({ children }) => (
    url ? (
      <Link to={url}>
        {children}
      </Link>
    ) : <a
      onClick={() => {
        handleClick(item.data)
      }}
      >
        {children}
      </a>
  )

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        position: 'relative',
        pb: footerAction ? '56px' : 'inherit',
        cursor: 'pointer',
        borderLeft: selected ? `4px solid ${retailer.brand_color}` : 'none',
      }}
    >
      <CardContainer>
        <ImageListItem key={item.url}
          sx={{
            height: '100%',
            width: '100%',
          }}
        >
          {topHeading &&
            <Stack sx={{ mb: 2 }}>
              <Typography sx={{ fontWeight: 300, color: '#090909', fontSize: '16px', textTransform: 'uppercase', whiteSpace: 'nowrap', overflow: 'hidden' }}>{topHeading}</Typography>
            </Stack>
          }

          <Stack
            direction="row"
            alignItems={'stretch'}
            spacing={1}
          >
            <Box
              sx={{
                flexShrink: 0,
                width: '4rem',
                p: 0.5,
              }}
            >
              <img
                className=''
                src={processedData?.imageUrl || imageSource}
                srcSet={processedData?.imageUrl || imageSource}
                alt={item.title}
                style={{
                  objectFit: 'contain',
                  width: '100%',
                  height: '100%',
                }}
              />
            </Box>

            <Divider
              orientation='vertical'
              variant="middle"
              flexItem
            />

            <Box
              sx={{
                py: 1,
                flexGrow: 1,
              }}
            >
              <Box sx={{ mb: 0 }}>
                <Typography sx={{
                  fontWeight: 'bold',
                  color: '#090909',
                  fontSize: '0.9rem',
                  textTransform: 'capitalize',
                  textDecoration: 'none',
                }}>
                  <Wysiwyg
                    truncateAfterLine={1}
                  >
                    {processedData?.title || item.title}
                  </Wysiwyg>
                </Typography>
              </Box>

              <Box sx={{ my: 0 }}>
                <Typography sx={{
                  fontWeight: 300,
                  color: '#090909',
                  fontSize: '0.8rem'
                }}>
                  <Wysiwyg
                    truncateAfterLine={1}
                  >
                    {processedData?.description || item?.description || '&nbsp;'}
                  </Wysiwyg>
                </Typography>
              </Box>
            </Box>
          </Stack>
        </ImageListItem>
      </CardContainer>

      {
        footerAction &&
          <Box
            sx={{
              position: 'absolute',
              bottom: '16px',
              left: '16px',
              right: '16px',
            }}
          >
            {footerAction}
          </Box>
      }
    </Box>
  );
}

export default HorizontalCard